import angular from 'angular';
import config from '../../../../app/global/env.config';

export default angular
  .module('doxy.global.common.services.routerHelperFactory', [])
  .factory('routerHelperFactory', function () {
    return routerHelperFactory;
  }).name;

const DOT_SUBDOMAIN_DIVIDER = '.';

export class RouterHelperFactory {
  constructor() {
    const { isDynamicEnv, dynamicEnvSubdomainDivider } = config;
    this.isDynamicEnv = isDynamicEnv;
    this.dynamicEnvSubdomainDivider = dynamicEnvSubdomainDivider;
  }

  getSubdomain() {
    const parts = window.location.host.split(/[,.:]/u);
    if (
      this.isDynamicEnv &&
      parts.length > 3 &&
      parts[0].includes(this.dynamicEnvSubdomainDivider)
    ) {
      return parts[0].split(this.dynamicEnvSubdomainDivider)[0];
    }

    /**
      As ngrok generates a custom subdomain we cannot determine the clinic.
      Used for local development when we need to expose our API.
    */
    const isNgrok = window.location.origin.includes('ngrok.io');
    const isEphemeral = window.location.origin.includes('doxy-ephemeral.me');
    if (isNgrok || isEphemeral) {
      // eslint-disable-next-line consistent-return
      return;
    }

    return parts.length === 3 ? parts[0] : undefined;
  }

  getBaseUrl() {
    //Fix for IE. Wasn't using institution and institutionHelper due to circular dependency.
    if (!window.location.origin) {
      return `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ':' + window.location.port : ''
      }`;
    } else {
      return window.location.origin;
    }
  }

  getSubdomainDivider() {
    return this.isDynamicEnv
      ? this.dynamicEnvSubdomainDivider
      : DOT_SUBDOMAIN_DIVIDER;
  }
}

export const routerHelperFactory = new RouterHelperFactory();
